<template>
  <div>
    <el-upload
      :action="url"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :on-error="handleError"
      :before-upload="beforeUpload"
      :headers="uploadHeader()"
      :multiple="false"
      :accept="accept"
      :data="data"
    >
      <slot name="uploadContent"></slot>
    </el-upload>
  </div>
</template>
  
  <script>
import Util from "@lib/util.js";
import BaseApi from "@lib/baseApi.js";
// import BMF from "browser-md5-file";
import axios from 'axios';
export default {
  data() {
    return {
      data: {},
      loading: false,

      url: "/common/upload",
      osskey: "",

      headers: {
        "x-oss-meta-fileSize": "", // 文件大小
        "Content-MD5": "", // md5
        // "Content-Type": "application/zip",
        "Content-Type": "binary",
      },
    };
  },
  props: {
    accept: {
      type: String,
      default: "",
    },
    bizType: {
      type: String,
      default: "imports",
    },
  },
  async mounted() {},

  methods: {
    handleAvatarSuccess(res, file) {
      this.$emit("loadingEnd");
      if (res.code == 200) {
        this.$emit("uploadSuccess", {
            ...res,
            file_name: file.name
        });
      } else {
        if (res.code == 102 || res.code == 103) {
          window.location.href = "/verification/login";
        } else {
          this.$message.error(res.message || "上传失败");
        }
      }
    },
    handleError() {
      this.$emit("loadingEnd");
      this.$message.error("上传失败");
    },
    async uploadFile(params) {
      console.log(params, "params");
      const formData = new FormData();
      formData.append("file", params.file);
      axios({
        url: this.url,
        method: "PUT",
        data: formData,
        _timeout: 15000,
        headers: this.headers,
      })
    },
    async beforeUpload(file) {
      this.data.fileName = file.name;
      console.log(file.name, 'file.name')
      let isLt30M = 30;
      if (this.accept) {
        let acceptList = this.accept.split(',');
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf("."));
        }
        console.log(fileExtension, 'fileExtension')
        const isTypeOk = acceptList.some((type) => {
          // if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
        if (!isTypeOk) {
          this.$message.error(
            `文件格式不正确, 请上传${acceptList.join("/")}格式文件!`
          );
          return false;
        }
      }
      if (this.uploadType == "contract") {
        isLt30M = file.size / 1024 / 1024 < this.data.maxSize;
        if (this.curCount >= this.data.maxCount) {
          this.$message.error(`上传的文件不能超过${this.data.maxCount}个!`);
          return false;
        } else if (!isLt30M) {
          this.$message.error(`上传的文件不能超过${this.data.maxSize}M!`);
          return false;
        } else {
          this.$emit("loading");
          return true;
        }
      } else {
        isLt30M = file.size / 1024 / 1024 < 30;
        if (!isLt30M) {
          this.$message.error("上传的文件不能超过30M!");
        } else {
          this.$emit("loading");
        }
        return isLt30M;
      }
    },
    async getOssUploadUrl(file) {
      return new Promise(async (resolve, reject) => {
        const md5 = await this.getMd5(file);
        const md5_16 = this.HexToBase64(md5);
        const md5Base64Str = encodeURIComponent(md5_16);
        console.log(md5, "md5");
        console.log(md5Base64Str, "md5Base64Str");

        this.headers["Content-MD5"] = md5_16;
        this.headers["x-oss-meta-fileSize"] = file.size;
        BaseApi.createRpcToken("/common/getOssUploadUrl", {
          bizType: this.bizType,
          md5Base64Str: md5Base64Str,
          filesize: file.size,
          filetype: "zip",
        }).then(
          (data) => {
            if (data.code === 200) {
              resolve(data.datas);
            }
          },
          (err) => {}
        );
      });
    },
    async getMd5(file) {
      return new Promise((resolve, reject) => {
        const bmf = new BMF();
        bmf.md5(file, (err, md5) => {
          if (err) {
            reject(err);
          }
          resolve(md5);
        });
      });
    },
    uploadHeader() {
      return {
        token: localStorage.token || "mVYUzIuJCAmoOjgiI0xaaW8mfqJGPq",
        "X-CSRF-Token": sessionStorage.token,
        "request-id": Util.getUID(),
      };
    },
    HexToBase64(sha1) {
      var digits =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
      var base64_rep = "";
      var ascv;
      var bit_arr = 0;
      var bit_num = 0;

      for (var n = 0; n < sha1.length; ++n) {
        if (sha1[n] >= "A" && sha1[n] <= "Z") {
          ascv = sha1.charCodeAt(n) - 55;
        } else if (sha1[n] >= "a" && sha1[n] <= "z") {
          ascv = sha1.charCodeAt(n) - 87;
        } else {
          ascv = sha1.charCodeAt(n) - 48;
        }

        bit_arr = (bit_arr << 4) | ascv;
        bit_num += 4;
        if (bit_num >= 6) {
          bit_num -= 6;

          base64_rep += digits[bit_arr >>> bit_num];
          bit_arr &= ~(-1 << bit_num);
        }
      }

      if (bit_num > 0) {
        bit_arr <<= 6 - bit_num;
        base64_rep += digits[bit_arr];
      }
      var padding = base64_rep.length % 4;

      if (padding > 0) {
        for (var n = 0; n < 4 - padding; ++n) {
          base64_rep += "=";
        }
      }
      return base64_rep;
    },
  },
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss">
</style>
  